import { render } from "./ViewTac.vue?vue&type=template&id=8a38f98c&scoped=true"
import script from "./ViewTac.vue?vue&type=script&lang=js"
export * from "./ViewTac.vue?vue&type=script&lang=js"

import "./ViewTac.vue?vue&type=style&index=0&id=8a38f98c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a38f98c"]])

export default __exports__